class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = Array.from(this.querySelectorAll('.product-tabs-header .product-tabs__tab'));
    this.tabDetails = Array.from(this.querySelectorAll('.product-tabs-details details'));
  }

  connectedCallback() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', () => this.openTab(button.dataset.tab));
    });
  }

  openTab(tab) {
    const details = this.tabDetails.find((detail) => detail.dataset.tab === tab);
    if (details && !details.open) details.open = true;

    this.tabButtons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.tab === tab);
    });
  }
}

customElements.define('product-tabs', ProductTabs);
